._presetItem_1d9p3_1 {
  position: absolute;
  cursor: pointer; }

._presetItem_1d9p3_1:hover ._presetItemLabel_1d9p3_5._hover_1d9p3_5 {
  display: block; }

._presetItem_1d9p3_1:hover ._infoWrapper_1d9p3_8 {
  opacity: 1; }

._smallGap_1d9p3_11 {
  overflow: visible; }

._smallGap_1d9p3_11 ._presetItemLabel_1d9p3_5 {
  bottom: -5px; }

._video_1d9p3_17 {
  position: absolute;
  top: 0; }

._videoPaused_1d9p3_21 {
  visibility: hidden; }

._liveText_1d9p3_24 {
  position: relative;
  margin-bottom: 14px;
  margin-left: 14px; }

._liveText_1d9p3_24:hover {
  color: #2b5672; }

._liveText_1d9p3_24:hover ._presetItemLabel_1d9p3_5 {
  visibility: visible; }

._liveText_1d9p3_24 ._presetItemLabel_1d9p3_5 {
  position: initial;
  visibility: hidden;
  display: block;
  font-size: 13px;
  margin-bottom: -4px; }

._presetItemLabel_1d9p3_5 {
  position: absolute;
  top: calc(100% - 14px);
  right: 0;
  left: 0;
  text-align: center;
  display: none;
  font-size: 12px;
  color: #2b5672; }

._presetItemLabel_1d9p3_5._alignLeft_1d9p3_52 {
  text-align: left;
  left: 11px; }

._presetItemLabel_1d9p3_5._always_1d9p3_56 {
  display: block; }

._presetItemLabel_1d9p3_5._never_1d9p3_59 {
  display: none; }

._infoWrapper_1d9p3_8 {
  opacity: 0; }

._selectionIndicator_1d9p3_65 {
  position: absolute;
  top: 0;
  right: -2px;
  height: 31px;
  width: 31px; }
